import { z } from 'zod';

const GeometryTypeDef = ['Point', 'LineString', 'Polygon'] as const;

export type GeometryType = (typeof GeometryTypeDef)[number];

export const geometryTypeSchema = z.enum(GeometryTypeDef);
